import { render, staticRenderFns } from "./NewsletterOptin.vue?vue&type=template&id=0c773b10&scoped=true&"
import script from "./NewsletterOptin.vue?vue&type=script&lang=js&"
export * from "./NewsletterOptin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c773b10",
  null
  
)

export default component.exports